<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'QACategoryCenter', to: { path: '/faq-category' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>[Warranty/FAQ/RMA]分類</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toQACategoryCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增分類</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <QACategoryCenterTable></QACategoryCenterTable>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QACategoryCenterTable from '@/views/G-3__QACategory/c/QACategoryCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    QACategoryCenterTable,
  },
  created() {
    this.clear();
    this.getQACategoryList();
  },
  methods: {
    ...mapActions('qacategory', {
      getQACategoryList: 'find',
      clear: 'clear',
    }),
    toQACategoryCreate() {
      this.$router.push('/faq-category/create');
    },
  },
};
</script>

<style></style>
